import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { unitResource } from '@/views/insurance/underwritingManage/request';
import { agencyResource } from '@/views/insurance/organizationalManage/request';
import { customerResource } from '@/views/system/customerManage/request';
import detailExportModal from './detailExportModal.vue';
import { personnelDetailsRecord, policyNoResource, operatorResource } from './request';
import operatingDetail from './operatingDetail.vue';
import moment from 'moment';
export default {
  components: {
    detailExportModal,
    operatingDetail
  },
  data() {
    const that = this;
    return {
      exportVisible: false,
      detailVisible: false,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${that.$t('共') + total + that.$t('条')}`;
        }
      },
      form: {
        unitId: undefined,
        agencyId: undefined,
        recordType: '',
        operator: undefined,
        policyNo: undefined,
        customerId: undefined,
        time: [],
        name: '',
        idNumber: ''
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: 'index',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '保单号'
        },
        dataIndex: 'policyNo',
        key: 'policyNo',
        align: 'center'
      }, {
        slots: {
          title: '人员名称'
        },
        dataIndex: 'name',
        key: 'name',
        align: 'center'
      }, {
        slots: {
          title: '身份证号'
        },
        dataIndex: 'idNumber',
        key: 'idNumber',
        align: 'center'
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'premium',
        key: 'premium',
        align: 'center'
      }, {
        slots: {
          title: '操作类型'
        },
        dataIndex: 'recordType',
        key: 'recordType',
        align: 'center',
        scopedSlots: {
          customRender: 'recordType'
        }
      }, {
        slots: {
          title: '操作人'
        },
        dataIndex: 'nickName',
        key: 'nickName',
        align: 'center'
      }, {
        slots: {
          title: '操作时间'
        },
        dataIndex: 'operatorTime',
        key: 'operatorTime',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 100,
        key: '9'
      }],
      data: [],
      unitList: [],
      customerList2: [],
      policyNoList: [],
      intermediaryList: [],
      policyId: undefined,
      personnelDetailsId: undefined,
      operatorList: []
    };
  },
  async created() {
    const unitList = await unitResource({});
    this.unitList = unitList;
    this.agencyFun();
    const customerList2 = await customerResource({});
    this.customerList2 = customerList2;
    if (customerList2.length == 0) {
      return false;
    }
    let arr = customerList2.filter(item => item.id == Number(sessionStorage.getItem('policyCustomerId')));
    this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('policyCustomerId')) : customerList2[0].id;
    sessionStorage.setItem('policyCustomerId', this.form.customerId);
    this.searchFun();
    await this.operatorResourceFn();
    await this.policyNoResourceFn();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    async getDataFun() {
      var _this$form$operator, _this$form$name, _this$form$idNumber;
      let policyItem = this.policyNoList.filter(item => item.policyNo === this.form.policyNo);
      let obj = {
        unitId: this.form.unitId,
        agencyId: this.form.agencyId,
        recordType: this.form.recordType,
        operator: ((_this$form$operator = this.form.operator) === null || _this$form$operator === void 0 ? void 0 : _this$form$operator.trim()) || '',
        // policyNo: this.form.policyNo,
        customerId: this.form.customerId,
        policyId: policyItem.length > 0 ? policyItem[0].id : '',
        name: ((_this$form$name = this.form.name) === null || _this$form$name === void 0 ? void 0 : _this$form$name.trim()) || '',
        idNumber: ((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 || (_this$form$idNumber = _this$form$idNumber.trim()) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.toLocaleUpperCase()) || ''
      };
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = this.form.time.length ? moment(this.form.time[0]).format('YYYY-MM-DD') : undefined;
      obj.endAt = this.form.time.length ? moment(this.form.time[1]).format('YYYY-MM-DD') : undefined;
      const res = await personnelDetailsRecord(obj);
      this.pagination.total = res.totalNum;
      this.data = res.items;
    },
    agencyFun() {
      this.form.agencyId = undefined;
      agencyResource({
        unitId: this.form.unitId
      }).then(res => {
        this.intermediaryList = res;
      });
    },
    agencyChange(val) {
      let arr = this.intermediaryList.filter(item => item.id == val);
      this.form.unitId = arr.length != 0 ? arr[0].unitId : undefined;
      if (!this.form.unitId) {
        this.agencyFun();
      }
    },
    async customerChange() {
      this.form.operator = undefined;
      this.form.policyNo = undefined;
      sessionStorage.setItem('policyCustomerId', this.form.customerId);
      await this.operatorResourceFn();
      await this.policyNoResourceFn();
    },
    async operatorResourceFn() {
      const res = await operatorResource({
        customerId: this.form.customerId
      });
      this.operatorList = res;
    },
    async policyNoResourceFn() {
      const res = await policyNoResource({
        customerId: this.form.customerId
      });
      this.policyNoList = res;
    },
    resetSearch() {
      this.form.unitId = undefined;
      this.form.agencyId = undefined;
      this.form.recordType = '';
      this.form.operator = undefined;
      this.form.policyNo = undefined;
      this.form.name = undefined;
      this.form.idNumber = undefined;
      this.form.time = [];
      this.searchFun();
    },
    openDetail(record) {
      this.policyId = record.policyId;
      this.personnelDetailsId = record.personnelDetailsId;
      this.detailVisible = true;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};